import type { CSSProperties, ReactNode } from 'react';
import { cx } from '@/lib/cx';
import styles from './ArchFrame.module.css';

export interface ArchFrameProps {
  children: ReactNode;
  /** `arch` arco de medio punto arriba · `circle` marco circular. */
  shape?: 'arch' | 'circle';
  /** Filete dorado alrededor del recorte. */
  bordered?: boolean;
  /** Proporcion del hueco (solo en `arch`). Por defecto vertical 3/4. */
  ratio?: string;
  className?: string;
  style?: CSSProperties;
}

/**
 * Mascara de arco / marco circular para imagenes — el recorte que llevan las
 * tarjetas de destino y los retratos en los mockups.
 * Se hace con `border-radius` + `overflow: hidden`, no con una imagen PNG
 * recortada: asi FORGE-BRAVO entrega la foto plana y el recorte es del sistema.
 */
export function ArchFrame({
  children,
  shape = 'arch',
  bordered = true,
  ratio = '3 / 4',
  className,
  style,
}: ArchFrameProps) {
  return (
    <div
      className={cx(styles.frame, styles[shape], bordered && styles.bordered, className)}
      style={{ ...style, ...(shape === 'arch' ? { aspectRatio: ratio } : null) }}
    >
      {children}
    </div>
  );
}
